import { render, staticRenderFns } from "./CartPage.vue?vue&type=template&id=842ac2f4&scoped=true"
import script from "./CartPage.vue?vue&type=script&lang=js"
export * from "./CartPage.vue?vue&type=script&lang=js"
import style0 from "./CartPage.vue?vue&type=style&index=0&id=842ac2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842ac2f4",
  null
  
)

export default component.exports